module.exports = __webpack_public_path__ + "ae50b272686f106dba4312f4d61abb95.png";